import each from 'lodash/each';
import cloneDeep from 'lodash/cloneDeep';
import pick from 'lodash/pick';
import map from 'lodash/map';
import isUndefined from 'lodash/isUndefined';

class SettingsTransformer {
  transformPixels(pixels) {
    let customVars = cloneDeep(pixels.facebook.custom_vars),
      flattenedCustomVars = [],
      payload = {};

    each(customVars, (customVarsArray, key) => {
      customVarsArray.pop();
      each(customVarsArray, customVar => flattenedCustomVars.push(customVar));
    });


    if (pixels.adroll.pixel_id) payload.adroll_pixel_id = pixels.adroll.pixel_id;
    if (pixels.adroll.adv_id) payload.adroll_advertiser_id = pixels.adroll.adv_id;
    if (pixels.custom) payload.custom_image_url = pixels.custom;
    if (pixels.facebook.id) payload.new_fb_pixel = pixels.facebook.id;
    if (flattenedCustomVars) payload.custom_fb_vars = flattenedCustomVars;
    if (pixels.google.id) payload.google_tracking_code = pixels.google.id;
    if (pixels.google.label) payload.google_retarget_code = pixels.google.label;
    if (pixels.perfect) payload.perfect_pixel_id = pixels.perfect;
    if (pixels.twitter) payload.twitter_pixel = pixels.twitter;
    if (pixels.tiktok) payload.tiktok_pixel_id = pixels.tiktok;
    if (pixels.pinterest) payload.pinterest_pixel_id = pixels.pinterest;

    return payload;
  }

  transformCampaign(campaign) {
    let payload = pick(campaign, ['name', 'description', 'auto_relaunch', 'show_goal', 'auto_extend', 'hide_marketplace']);

    payload.category_id = campaign._embedded.category.id;
    payload.shipping_discount = parseFloat(campaign.shipping_discount_amount);
    payload.show_timer = campaign.show_sales_timer;
    payload.hide_feed = campaign.hide_feeds;
    payload.sales_padding = 0; //campaign.pad_sales;
    payload.tags = map(campaign._embedded.tags, tag => tag.name);
    payload.campaign_length = campaign.next_relaunch_length;
    payload.x_sell_tag = campaign.x_sell_tag_id;

    if (!isUndefined(campaign.hide_on_homepage)) payload.hidden_on_homepage = campaign.hide_on_homepage;
    if (!isUndefined(campaign.domain_id)) payload.domain_id = campaign.domain_id;

    return payload;
  }

  transformMetadata(meta) {
    return {
      meta_title: meta.title,
      meta_keywords: meta.keywords,
      meta_description: meta.description
    };
  }

  transformOpengraph(opengraph) {
    return {
      og_title: opengraph.title,
      og_image_uri: opengraph.image,
      og_description: opengraph.description
    };
  }

  transformTwitter(twitter) {
    return {
      twitter_title: twitter.title,
      twitter_image_uri: twitter.image,
      twitter_description: twitter.description
    };
  }
}

export default new SettingsTransformer();